
import FormPreview from 'vux/src/components/form-preview/index.vue'
import XTable from 'vux/src/components/x-table/index.vue'

export default {
components: {
FormPreview,
XTable
},
data () {
return {
list: []
}
},
activated: function () {
this.list = [ {
label: '运输方式名称',
value: this.$route.params.Item.PSM_Name
}, {
label: '运输方式说明',
value: this.$route.params.Item.PSM_Reamrk
}]
console.log(this.$route.params)
}
}



// WEBPACK FOOTER //
// ./src/components/ShappingModeDetail.vue